interface RainbowError {
  message: String;
  imgLg: String;
  imgMd: String;
  imgSm: String;
}

const pathToImg: String = 'http://static.r.pl/rpl-cdn/images/';

// Błędy spłaszczamy do dwóch typów jak na razie. Tak na prawde wszystkie błędy sprowadzają się do errora 400.
// Wyjątkiem są błędy "500".

const err4xx: RainbowError = {
  message: 'Sprawdź, czy adres strony został wpisany prawidłowo lub przejdź do strony głównej i zacznij od początku',
  imgLg: `${pathToImg}error-404-lg.png`,
  imgMd: `${pathToImg}error-404-md.png`,
  imgSm: `${pathToImg}error-404-sm.png`,
};

const err5xx: RainbowError = {
  message: 'Sprawdź, czy adres strony został wpisany prawidłowo lub przejdź do strony głównej i zacznij od początku',
  imgLg: `${pathToImg}error-500-lg.png`,
  imgMd: `${pathToImg}error-500-md.png`,
  imgSm: `${pathToImg}error-500-sm.png`,
};

// Error 500 (server side rendering) są niestety na stronie statycznej ulokowane w "app/views/error.html"
// Jeżeli wystąpi Error po stronie klienta to dopiero wtedy wpadnie w error skonfigurowany w tym miejscu
const errors: { [key: string]: RainbowError } = {
  4: err4xx,
  5: err5xx,
};
export default errors;
